
import { $t } from 'src/services/i18n';

export const AppMenus = {
    carsdrivercarheader: [
        {
          "label": $t('register'),
          "align": "left",
          "sortable": false,
          "name": "register",
          "field": "register"
        },
        {
          "label": $t('brand'),
          "align": "left",
          "sortable": false,
          "name": "brand",
          "field": "brand"
        },
        {
          "label": $t('model'),
          "align": "left",
          "sortable": false,
          "name": "model",
          "field": "model"
        },
        {
          "label": "",
          "align": "right",
          "sortable": false,
          "name": "btnactions",
          "field": ""
        }
    ],
    driverssetdriverheader: [
        {
          "label": $t('name'),
          "align": "left",
          "sortable": false,
          "name": "drivers_name",
          "field": "drivers_name"
        },
        {
          "label": $t('license'),
          "align": "left",
          "sortable": false,
          "name": "drivers_license",
          "field": "drivers_license"
        },
        {
          "label": $t('status'),
          "align": "left",
          "sortable": false,
          "name": "tdriverstatus",
          "field": "tdriverstatus"
        },
        {
          "label": "",
          "align": "right",
          "sortable": false,
          "name": "btnactions",
          "field": ""
        }
    ],
    drivercarsetcarheader: [
        {
          "label": $t('register'),
          "align": "left",
          "sortable": false,
          "name": "cars_register",
          "field": "cars_register"
        },
        {
          "label": $t('brand'),
          "align": "left",
          "sortable": false,
          "name": "cars_brand",
          "field": "cars_brand"
        },
        {
          "label": $t('model'),
          "align": "left",
          "sortable": false,
          "name": "cars_model",
          "field": "cars_model"
        },
        {
          "label": "Status da viatura",
          "align": "left",
          "sortable": false,
          "name": "tstatus",
          "field": "tstatus"
        },
        {
          "label": "",
          "align": "right",
          "sortable": false,
          "name": "btnactions",
          "field": ""
        }
    ],


	navbarTopRightItems: [
  {
    "path": "/vdsrequests",
    "label": $t('vdsRequests'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  }
],
	navbarTopLeftItems: [
  {
    "path": "/vdsrequests",
    "label": $t('vdsRequests'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  }
],
	navbarSideLeftItems: [
  {
    "path": "/home",
    "label": $t('home'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/driver_calendar",
    "label": $t('driverCalendar'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/myplan",
    "label": $t('myplan'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/changepassword",
    "label": $t('changepassword'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/logout",
    "label": $t('logout'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/mycompany",
    "label": $t('mycompany'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/cars/listfleet",
    "label": $t('listfleet'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/contract_itens",
    "label": $t('contractItens'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/geolocations",
    "label": $t('geolocations'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/roles",
    "label": $t('roles'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/users",
    "label": $t('users'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/reports_log",
    "label": $t('reportsLog'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/vdsrequests",
    "label": $t('vdsRequests'),
    "icon": "fas fa-globe",
    "iconcolor": "",
    "target": "",
    "submenu": []
  }
],
	AddressesListHeaderItems: [
  {
    "label": $t(''),
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	BookletPageListHeaderItems: [
  {
    "label": $t('defaultcar'),
    "align": "left",
    "sortable": false,
    "name": "defaultcar",
    "field": "defaultcar"
  },
  {
    "label": $t('startKm'),
    "align": "left",
    "sortable": false,
    "name": "start_km",
    "field": "start_km"
  },
  {
    "label": $t('endKm'),
    "align": "left",
    "sortable": false,
    "name": "end_km",
    "field": "end_km"
  },
  {
    "label": $t('total'),
    "align": "left",
    "sortable": false,
    "name": "km_total",
    "field": "km_total"
  },
  {
    "label": $t('obs'),
    "align": "left",
    "sortable": false,
    "name": "obs",
    "field": "obs"
  },
  {
    "label": $t('log'),
    "align": "left",
    "sortable": false,
    "name": "log",
    "field": "log"
  },
  {
    "label": $t('closed'),
    "align": "left",
    "sortable": false,
    "name": "closed",
    "field": "closed"
  }
],
	statusItems: [
	{value: "Active", label: $t('activeConsumesLicense')},
	{value: "Filed", label: $t('filedNotConsumesLicense')}
    ],
	ClientContractListHeaderItems: [
  {
    "label": $t('contract'),
    "align": "left",
    "sortable": true,
    "name": "contract",
    "field": "contract"
  },
  {
    "label": $t('productName'),
    "align": "left",
    "sortable": false,
    "name": "product_name",
    "field": "product_name"
  },
  {
    "label": $t('dateDue'),
    "align": "left",
    "sortable": true,
    "name": "date_due",
    "field": "date_due"
  },
  {
    "label": $t('dateActivated'),
    "align": "left",
    "sortable": true,
    "name": "date_activated",
    "field": "date_activated"
  },
  {
    "label": $t('invoice'),
    "align": "left",
    "sortable": false,
    "name": "invoice",
    "field": "invoice"
  },
  {
    "label": $t('drivers'),
    "align": "left",
    "sortable": false,
    "name": "drivers",
    "field": "drivers"
  },
  {
    "label": $t('cars'),
    "align": "left",
    "sortable": false,
    "name": "cars",
    "field": "cars"
  },
  {
    "label": $t('totalValue'),
    "align": "left",
    "sortable": true,
    "name": "total",
    "field": "total"
  }
],
	ClientRequestsListHeaderItems: [
  {
    "label": $t('request'),
    "align": "left",
    "sortable": false,
    "name": "request",
    "field": "request"
  },
  {
    "label": $t('drivers'),
    "align": "left",
    "sortable": false,
    "name": "drivers",
    "field": "drivers"
  },
  {
    "label": $t('cars'),
    "align": "left",
    "sortable": false,
    "name": "cars",
    "field": "cars"
  },
  {
    "label": $t('tstatus'),
    "align": "left",
    "sortable": false,
    "name": "tStatus",
    "field": "tStatus"
  },
  {
    "label": $t('invoice'),
    "align": "left",
    "sortable": false,
    "name": "invoice",
    "field": "invoice"
  },
  {
    "label": $t('orderDate'),
    "align": "left",
    "sortable": false,
    "name": "date_created",
    "field": "date_created"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "actions",
    "field": "actions"
  }
],
	ClientsListHeaderItems: [
  {
    "label": $t('name'),
    "align": "left",
    "sortable": false,
    "name": "name",
    "field": "name"
  },
  {
    "label": $t('nipc'),
    "align": "left",
    "sortable": false,
    "name": "nipc",
    "field": "nipc"
  },
  {
    "label": $t('activity'),
    "align": "left",
    "sortable": false,
    "name": "activity",
    "field": "activity"
  },
  {
    "label": $t('license'),
    "align": "left",
    "sortable": false,
    "name": "license",
    "field": "license"
  },
  {
    "label": $t('clientSince'),
    "align": "left",
    "sortable": false,
    "name": "date_created",
    "field": "date_created"
  }
],
	ConfigListHeaderItems: [
  {
    "label": $t('maxCars'),
    "align": "left",
    "sortable": false,
    "name": "max_cars",
    "field": "max_cars"
  },
  {
    "label": $t('maxDrivers'),
    "align": "left",
    "sortable": false,
    "name": "max_drivers",
    "field": "max_drivers"
  },
  {
    "label": $t('maxFleets'),
    "align": "left",
    "sortable": false,
    "name": "max_fleets",
    "field": "max_fleets"
  }
],
	ContractItensListHeaderItems: [
  {
    "label": $t('configParameter'),
    "align": "left",
    "sortable": false,
    "name": "config_parameter",
    "field": "config_parameter"
  },
  {
    "label": $t('quantity'),
    "align": "left",
    "sortable": false,
    "name": "quantity",
    "field": "quantity"
  },
  {
    "label": $t('unit'),
    "align": "left",
    "sortable": false,
    "name": "unit",
    "field": "unit"
  },
  {
    "label": $t('contractsInvoice'),
    "align": "left",
    "sortable": false,
    "name": "contracts_invoice",
    "field": "contracts_invoice"
  },
  {
    "label": $t('contractsDateIssued'),
    "align": "left",
    "sortable": false,
    "name": "contracts_date_issued",
    "field": "contracts_date_issued"
  },
  {
    "label": $t('contractsDateDue'),
    "align": "left",
    "sortable": false,
    "name": "contracts_date_due",
    "field": "contracts_date_due"
  }
],
	ContractsListHeaderItems: [
  {
    "label": $t(''),
    "align": "left",
    "sortable": false,
    "name": "masterdetailbtn",
    "field": ""
  },
  {
    "label": $t('contract'),
    "align": "left",
    "sortable": false,
    "name": "contract",
    "field": "contract"
  },
  {
    "label": $t('request'),
    "align": "left",
    "sortable": false,
    "name": "request",
    "field": "request"
  },
  {
    "label": $t('client'),
    "align": "left",
    "sortable": false,
    "name": "client",
    "field": "client"
  },
  {
    "label": $t('address'),
    "align": "left",
    "sortable": false,
    "name": "address",
    "field": "address"
  },
  {
    "label": $t('product'),
    "align": "left",
    "sortable": false,
    "name": "product",
    "field": "product"
  },
  {
    "label": $t('payment'),
    "align": "left",
    "sortable": false,
    "name": "payment",
    "field": "payment"
  },
  {
    "label": $t('invoice'),
    "align": "left",
    "sortable": false,
    "name": "invoice",
    "field": "invoice"
  },
  {
    "label": $t('dateIssued'),
    "align": "left",
    "sortable": false,
    "name": "date_issued",
    "field": "date_issued"
  },
  {
    "label": $t('dateDue'),
    "align": "left",
    "sortable": false,
    "name": "date_due",
    "field": "date_due"
  },
  {
    "label": $t('datePayed'),
    "align": "left",
    "sortable": false,
    "name": "date_payed",
    "field": "date_payed"
  },
  {
    "label": $t('dateActivated'),
    "align": "left",
    "sortable": false,
    "name": "date_activated",
    "field": "date_activated"
  },
  {
    "label": $t('dateDeactivated'),
    "align": "left",
    "sortable": false,
    "name": "date_deactivated",
    "field": "date_deactivated"
  },
  {
    "label": $t('reviewedBy'),
    "align": "left",
    "sortable": false,
    "name": "reviewed_by",
    "field": "reviewed_by"
  },
  {
    "label": $t('dateCreated'),
    "align": "left",
    "sortable": false,
    "name": "date_created",
    "field": "date_created"
  },
  {
    "label": $t('dateUpdated'),
    "align": "left",
    "sortable": false,
    "name": "date_updated",
    "field": "date_updated"
  },
  {
    "label": $t('obs'),
    "align": "left",
    "sortable": false,
    "name": "obs",
    "field": "obs"
  },
  {
    "label": $t('status'),
    "align": "left",
    "sortable": false,
    "name": "status",
    "field": "status"
  },
  {
    "label": $t('permalink'),
    "align": "left",
    "sortable": false,
    "name": "permalink",
    "field": "permalink"
  }
],
	DriverCalendarListHeaderItems: [
  {
    "label": $t('page'),
    "align": "left",
    "sortable": false,
    "name": "page",
    "field": "page"
  },
  {
    "label": $t('line'),
    "align": "left",
    "sortable": false,
    "name": "line",
    "field": "line"
  },
  {
    "label": $t('driver'),
    "align": "left",
    "sortable": false,
    "name": "driver",
    "field": "driver"
  },
  {
    "label": $t('car'),
    "align": "left",
    "sortable": false,
    "name": "car",
    "field": "car"
  },
  {
    "label": $t('status'),
    "align": "left",
    "sortable": false,
    "name": "status",
    "field": "status"
  },
  {
    "label": $t('week'),
    "align": "left",
    "sortable": false,
    "name": "week",
    "field": "week"
  },
  {
    "label": $t('weekstartdate'),
    "align": "left",
    "sortable": false,
    "name": "weekstartdate",
    "field": "weekstartdate"
  },
  {
    "label": $t('startDay'),
    "align": "left",
    "sortable": false,
    "name": "start_day",
    "field": "start_day"
  },
  {
    "label": $t('startTime'),
    "align": "left",
    "sortable": false,
    "name": "start_time",
    "field": "start_time"
  },
  {
    "label": $t('endDay'),
    "align": "left",
    "sortable": false,
    "name": "end_day",
    "field": "end_day"
  },
  {
    "label": $t('endTime'),
    "align": "left",
    "sortable": false,
    "name": "end_time",
    "field": "end_time"
  },
  {
    "label": $t('duration'),
    "align": "left",
    "sortable": false,
    "name": "duration",
    "field": "duration"
  },
  {
    "label": $t('statusDuration'),
    "align": "left",
    "sortable": false,
    "name": "status_duration",
    "field": "status_duration"
  },
  {
    "label": $t('color'),
    "align": "left",
    "sortable": false,
    "name": "color",
    "field": "color"
  }
],
	DrivercarListHeaderItems: [],
	selfemployedItems: [
{value: "false", label: $t('false')},
	{value: "true", label: $t('true')}
    ],
	GeolocationsListHeaderItems: [
  {
    "label": $t('id'),
    "align": "left",
    "sortable": false,
    "name": "id",
    "field": "id"
  },
  {
    "label": $t('driver'),
    "align": "left",
    "sortable": false,
    "name": "driver",
    "field": "driver"
  },
  {
    "label": $t('page'),
    "align": "left",
    "sortable": false,
    "name": "page",
    "field": "page"
  },
  {
    "label": $t('car'),
    "align": "left",
    "sortable": false,
    "name": "car",
    "field": "car"
  },
  {
    "label": $t('date'),
    "align": "left",
    "sortable": false,
    "name": "date",
    "field": "date"
  },
  {
    "label": $t('latitude'),
    "align": "left",
    "sortable": false,
    "name": "latitude",
    "field": "latitude"
  },
  {
    "label": $t('longitude'),
    "align": "left",
    "sortable": false,
    "name": "longitude",
    "field": "longitude"
  },
  {
    "label": $t('type'),
    "align": "left",
    "sortable": false,
    "name": "type",
    "field": "type"
  },
  {
    "label": $t('status'),
    "align": "left",
    "sortable": false,
    "name": "status",
    "field": "status"
  },
  {
    "label": $t('reverse'),
    "align": "left",
    "sortable": false,
    "name": "reverse",
    "field": "reverse"
  }
],
	ListsListHeaderItems: [
  {
    "label": $t('id'),
    "align": "left",
    "sortable": false,
    "name": "id",
    "field": "id"
  },
  {
    "label": $t('type'),
    "align": "left",
    "sortable": false,
    "name": "type",
    "field": "type"
  },
  {
    "label": $t('label'),
    "align": "left",
    "sortable": false,
    "name": "label",
    "field": "label"
  },
  {
    "label": $t('value'),
    "align": "left",
    "sortable": false,
    "name": "value",
    "field": "value"
  },
  {
    "label": $t('text'),
    "align": "left",
    "sortable": false,
    "name": "text",
    "field": "text"
  },
  {
    "label": $t('reviewedBy'),
    "align": "left",
    "sortable": false,
    "name": "reviewed_by",
    "field": "reviewed_by"
  }
],
	ProductsListHeaderItems: [
  {
    "label": $t('product'),
    "align": "left",
    "sortable": false,
    "name": "product",
    "field": "product"
  },
  {
    "label": $t('name'),
    "align": "left",
    "sortable": false,
    "name": "name",
    "field": "name"
  },
  {
    "label": $t('description'),
    "align": "left",
    "sortable": false,
    "name": "description",
    "field": "description"
  },
  {
    "label": $t('timeallowance'),
    "align": "left",
    "sortable": false,
    "name": "timeallowance",
    "field": "timeallowance"
  },
  {
    "label": $t('maxFleets'),
    "align": "left",
    "sortable": false,
    "name": "max_fleets",
    "field": "max_fleets"
  },
  {
    "label": $t('maxCars'),
    "align": "left",
    "sortable": false,
    "name": "max_cars",
    "field": "max_cars"
  },
  {
    "label": $t('maxDrivers'),
    "align": "left",
    "sortable": false,
    "name": "max_drivers",
    "field": "max_drivers"
  },
  {
    "label": $t('reviewedBy'),
    "align": "left",
    "sortable": false,
    "name": "reviewed_by",
    "field": "reviewed_by"
  },
  {
    "label": $t('dateCreated'),
    "align": "left",
    "sortable": false,
    "name": "date_created",
    "field": "date_created"
  },
  {
    "label": $t('dateUpdated'),
    "align": "left",
    "sortable": false,
    "name": "date_updated",
    "field": "date_updated"
  },
  {
    "label": $t('unitiCost'),
    "align": "left",
    "sortable": false,
    "name": "uniti_cost",
    "field": "uniti_cost"
  },
  {
    "label": $t('iva'),
    "align": "left",
    "sortable": false,
    "name": "iva",
    "field": "iva"
  }
],
	ReportsListHeaderItems: [
  {
    "label": $t('report'),
    "align": "left",
    "sortable": false,
    "name": "report",
    "field": "report"
  },
  {
    "label": $t('driver'),
    "align": "left",
    "sortable": false,
    "name": "driver",
    "field": "driver"
  },
  {
    "label": $t('dateFrom'),
    "align": "left",
    "sortable": false,
    "name": "date_from",
    "field": "date_from"
  },
  {
    "label": $t('dateTo'),
    "align": "left",
    "sortable": false,
    "name": "date_to",
    "field": "date_to"
  },
  {
    "label": $t('format'),
    "align": "left",
    "sortable": false,
    "name": "format",
    "field": "format"
  },
  {
    "label": $t('description'),
    "align": "left",
    "sortable": false,
    "name": "description",
    "field": "description"
  },
  {
    "label": $t('filename'),
    "align": "left",
    "sortable": false,
    "name": "filename",
    "field": "filename"
  },
  {
    "label": $t('dateCreated'),
    "align": "left",
    "sortable": false,
    "name": "date_created",
    "field": "date_created"
  },
  {
    "label": $t('dateUpdated'),
    "align": "left",
    "sortable": false,
    "name": "date_updated",
    "field": "date_updated"
  },
  {
    "label": $t(''),
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	ReportsLogListHeaderItems: [
  {
    "label": $t('report'),
    "align": "left",
    "sortable": false,
    "name": "report",
    "field": "report"
  },
  {
    "label": $t('user'),
    "align": "left",
    "sortable": false,
    "name": "user",
    "field": "user"
  },
  {
    "label": $t('driver'),
    "align": "left",
    "sortable": false,
    "name": "driver",
    "field": "driver"
  },
  {
    "label": $t('dateFrom'),
    "align": "left",
    "sortable": false,
    "name": "date_from",
    "field": "date_from"
  },
  {
    "label": $t('dateTo'),
    "align": "left",
    "sortable": false,
    "name": "date_to",
    "field": "date_to"
  },
  {
    "label": $t('format'),
    "align": "left",
    "sortable": false,
    "name": "format",
    "field": "format"
  },
  {
    "label": $t('description'),
    "align": "left",
    "sortable": false,
    "name": "description",
    "field": "description"
  },
  {
    "label": $t('to'),
    "align": "left",
    "sortable": false,
    "name": "to",
    "field": "to"
  },
  {
    "label": $t('cc'),
    "align": "left",
    "sortable": false,
    "name": "cc",
    "field": "cc"
  },
  {
    "label": $t('filename'),
    "align": "left",
    "sortable": false,
    "name": "filename",
    "field": "filename"
  },
  {
    "label": $t('dateCreated'),
    "align": "left",
    "sortable": false,
    "name": "date_created",
    "field": "date_created"
  },
  {
    "label": $t('dateUpdated'),
    "align": "left",
    "sortable": false,
    "name": "date_updated",
    "field": "date_updated"
  },
  {
    "label": $t(''),
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	RequestsListHeaderItems: [
  {
    "label": $t('request'),
    "align": "left",
    "sortable": false,
    "name": "request",
    "field": "request"
  },
  {
    "label": $t('drivers'),
    "align": "left",
    "sortable": false,
    "name": "drivers",
    "field": "drivers"
  },
  {
    "label": $t('cars'),
    "align": "left",
    "sortable": false,
    "name": "cars",
    "field": "cars"
  },
  {
    "label": $t('status'),
    "align": "left",
    "sortable": false,
    "name": "status",
    "field": "status"
  },
  {
    "label": $t('dateUpdated'),
    "align": "left",
    "sortable": false,
    "name": "date_updated",
    "field": "date_updated"
  },
  {
    "label": $t('contractsInvoice'),
    "align": "left",
    "sortable": false,
    "name": "contracts_invoice",
    "field": "contracts_invoice"
  },
  {
    "label": $t('contractsDateCreated'),
    "align": "left",
    "sortable": false,
    "name": "contracts_date_created",
    "field": "contracts_date_created"
  }
],
	paymentItems: [
{value: "Year", label: $t('anual')}
    ],
	RolesListHeaderItems: [
  {
    "label": $t(''),
    "align": "left",
    "sortable": false,
    "name": "masterdetailbtn",
    "field": ""
  },
  {
    "label": $t('roleId'),
    "align": "left",
    "sortable": false,
    "name": "role_id",
    "field": "role_id"
  },
  {
    "label": $t('roleName'),
    "align": "left",
    "sortable": false,
    "name": "role_name",
    "field": "role_name"
  }
],
	StartEndListHeaderItems: [
  {
    "label": $t('atividade'),
    "align": "left",
    "sortable": false,
    "name": "c_status",
    "field": "c_status"
  },
  {
    "label": $t('incio'),
    "align": "left",
    "sortable": false,
    "name": "start_date",
    "field": "start_date"
  },
  {
    "label": $t('trmino'),
    "align": "left",
    "sortable": false,
    "name": "end_date",
    "field": "end_date"
  },
  {
    "label": $t('activityTime'),
    "align": "left",
    "sortable": false,
    "name": "activity_time",
    "field": "activity_time"
  }
],
	TotalHoursDayListHeaderItems: [
  {
    "label": $t('rest'),
    "align": "left",
    "sortable": false,
    "name": "rest",
    "field": "rest"
  },
  {
    "label": $t('driveA'),
    "align": "left",
    "sortable": false,
    "name": "drive",
    "field": "drive"
  },
  {
    "label": $t('available'),
    "align": "left",
    "sortable": false,
    "name": "available",
    "field": "available"
  },
  {
    "label": $t('otherWorkB'),
    "align": "left",
    "sortable": false,
    "name": "other_work",
    "field": "other_work"
  },
  {
    "label": $t('otherJobC'),
    "align": "left",
    "sortable": false,
    "name": "other_job",
    "field": "other_job"
  },
  {
    "label": $t('aBC'),
    "align": "left",
    "sortable": false,
    "name": "activities_times",
    "field": "activities_times"
  }
],
	UsersListHeaderItems: [
  {
    "label": $t('name'),
    "align": "left",
    "sortable": false,
    "name": "name",
    "field": "name"
  },
  {
    "label": $t('email'),
    "align": "left",
    "sortable": false,
    "name": "email",
    "field": "email"
  },
  {
    "label": $t('userRoleId'),
    "align": "left",
    "sortable": false,
    "name": "user_role_id",
    "field": "user_role_id"
  },
  {
    "label": $t('accountStatus'),
    "align": "left",
    "sortable": false,
    "name": "account_status",
    "field": "account_status"
  }
],

    exportFormats: {
        print: {
			label: 'Print',
			color: 'blue',
            icon: 'fas fa-print',
            id: 'print',
            ext: '',
        },
        pdf: {
			label: 'Pdf',
			color: 'red',
            icon: 'fas fa-file-pdf',
            id: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
			color: 'green',
            icon: 'fas fa-file-excel',
            id: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
			color: 'teal',
            icon: 'fas fa-file-csv',
            id: 'csv',
            ext: 'csv',
        },
    },
    locales: {
  "en-US": "English",
  "pt": "Portuguese",
  "es-ES": "Espanol"
}
}
